var _rect, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentCenterActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.0918,
    y: 0.0488281,
    width: 21.5393,
    height: 28.0011,
    rx: 2,
    fill: "url(#paint0_linear_524_22794)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1.93994,
    width: 23.2624,
    height: 28.1088,
    rx: 3,
    fill: "url(#paint1_linear_524_22794)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.98438,
    y: 7.80273,
    width: 8.61572,
    height: 2.15393,
    rx: 1.07697,
    fill: "#E9F4FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.98438,
    y: 12.1108,
    width: 15.0775,
    height: 2.15393,
    rx: 1.07697,
    fill: "#E9F4FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.98438,
    y: 16.4185,
    width: 15.0775,
    height: 8.61572,
    rx: 1,
    fill: "#E9F4FF",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_22794",
    x1: 14.8614,
    y1: 0.0488281,
    x2: 14.8614,
    y2: 21.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB9EE",
    stopOpacity: 0.51
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_524_22794",
    x1: 11.6312,
    y1: 1.93994,
    x2: 11.6312,
    y2: 30.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E97EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB9EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCenterActive);
export default "https://c.d2cgo.com/dtc_center-setting/v19/assets/static/media/contentCenter_active.f56c6e21f37db9c82837941cc19535a6.svg";
export { ForwardRef as ReactComponent };